import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { nullSafe } from 'Utility/globalMethods';
import { portalModalSelector } from 'Store/selectors';
import { goPopup } from 'Store/actions/portalModalActions';
import { routeElectronicPurse } from 'Store/selectors';
import * as actionLayer from '../../modules/ElectronicPurseActions';
import DeleteElectronicPurseModal from './DeleteEPursePopup';

const mapDispatchToProps = (dispatch) => ({
	deleteItem: (item) => dispatch(actionLayer.deleteElectronicPurse.request(item)),
	closeModal: () => dispatch(goPopup('')),
	...bindActionCreators(actionLayer, dispatch),
});

const mapStateToProps = (state) => ({
	payload: nullSafe(() => portalModalSelector(state).data.payload, ''),
	isLoading: routeElectronicPurse(state).isLoading,
});

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps) => ({
	...stateProps,
	actions: dispatchProps,
}))(DeleteElectronicPurseModal);
